import { Chip, TableCell, TableRow, Typography } from "@mui/material";
import { IProfitLossResumedDto } from "../../../../interfaces/dashboard/IProfitLossResumedDto";
import { formatPriceToDolar } from "../../../../common/utils/number";
import { colorByValue } from "../../../../common/utils/color";

export default function ProfitLossResumedTotals( props: { profitLossList: IProfitLossResumedDto[] }) {
    const { profitLossList } = props;

    const totalInvestedSum = profitLossList.reduce((acc, item) => acc + item.totalInvested, 0);
    const totalSelledSum = profitLossList.reduce((acc, item) => acc + item.totalSelled, 0);
    const totalAmountSum = profitLossList.reduce((acc, item) => acc + item.totalAmount, 0);
    const profitLossSum = profitLossList.reduce((acc, item) => acc + item.profitLoss, 0);
    const profitLossPecentageTotal = profitLossSum === 0 && totalInvestedSum === 0 ? 0 : parseFloat((profitLossSum / totalInvestedSum * 100).toFixed(2));


    return (
        <>
            <TableRow
                key="subtotal"
                sx={{
                    backgroundColor: 'rgba(255,215,0,0.08)',
                    borderTop: '2px solid rgba(255,215,0,0.35)',
                    '& td': { borderBottom: 'none' },
                }}
            >
                <TableCell align="left">
                    <Typography fontWeight={700} fontSize="0.85rem" sx={{ textTransform: 'uppercase', letterSpacing: 0.5 }}>
                        Totais
                    </Typography>
                </TableCell>
                <TableCell align="left">
                    <Typography fontWeight={700}>{formatPriceToDolar(totalInvestedSum)}</Typography>
                </TableCell>
                <TableCell align="left">
                    <Typography fontWeight={700}>{formatPriceToDolar(totalSelledSum)}</Typography>
                </TableCell>
                <TableCell align="left">
                    <Typography fontWeight={700}>{formatPriceToDolar(totalAmountSum)}</Typography>
                </TableCell>
                <TableCell align="left">
                    <Typography fontWeight={700} color={colorByValue(profitLossSum)}>
                        {formatPriceToDolar(profitLossSum)}
                    </Typography>
                </TableCell>
                <TableCell align="right">
                    <Chip
                        label={`${profitLossPecentageTotal}%`}
                        size="small"
                        color={colorByValue(profitLossPecentageTotal) as 'success' | 'error'}
                        sx={{ fontWeight: 700, fontSize: '0.75rem', borderRadius: '6px' }}
                    />
                </TableCell>
            </TableRow>
        </>
    )
}